module.exports = __webpack_public_path__ + "img/contact.e2b7bf71.svg";